import { collection, query, where, getDocs, limit as firestoreLimit } from "firebase/firestore";
import utils from "./firebaseUtils";
import logging from "utils/logging";

const log = logging.getLogger("firebase/trivia");

const TRIVIA_COLLECTION = "triviaFacts";

const fetchApprovedTriviaFacts = async (sampleLimit = 50) => {
  const db = utils.firestore();
  const q = query(
    collection(db, TRIVIA_COLLECTION),
    where("status", "==", "approved"),
    firestoreLimit(sampleLimit)
  );
  const snap = await getDocs(q);
  const facts = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  log.debug(`Fetched ${facts.length} approved trivia facts`);
  return facts;
};

const api = {
  fetchApprovedTriviaFacts,
};

export default api;
